import { render, staticRenderFns } from "./MerchantBonus.vue?vue&type=template&id=5da8971a&scoped=true"
import script from "./MerchantBonus.vue?vue&type=script&lang=js"
export * from "./MerchantBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8971a",
  null
  
)

export default component.exports